import React from "react";
import leftPng from "../../../../../content/images/left.png";
import dateTimePng from "../../../../../content/images/date-time.png";
import $ from "jquery";
import { css } from "@emotion/core";
import * as spinner from "react-spinners";
import MyContext from "../../../../../api/context/my-context";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { fillDetailOrganization } from "../common/commonFunctions";
class Detail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  override = css`
    background: rgba(0, 0, 0, 0);
    z-index: 1000;
    /* background: linear-gradient(to left, #00c6ff, #0072ff); */
    font-family: arial;
    width: 110%;
    height: 110%;
    position: fixed;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: center;
    padding-top: 3%;
    padding-left: 29%;
  `;
  async componentDidMount() {
    $("#detail-button").click(function () {
      $("#tableSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
      $("#editSide").addClass("d-none");
      $("#organisatie-detail").addClass("d-none");
      $("#detailSide").removeAttr("name");
    });
    $("#edit-button").click(function () {
      $("#editSide").removeClass("d-none");
      $("#detailSide").addClass("d-none");
    });
    $("#return-detail").click(function () {
      $("#detailSide").removeClass("d-none");
      $("#editSide").addClass("d-none");
    });

    $(document).on("click", "#user-organizitaion", async (result) => {
      await omnimap
        .GetRowOfDetailAction(
          result.target.name,
          window.$catalog_management_units_token
        )
        .then((result) => {
          result.data &&
            result.data.content &&
            fillDetailOrganization(result.data.content.algemeen);
          if ($("#detailSide").attr("class") == "d-none") {
            $("#tableSide").addClass("d-none");
          } else {
            $("#detailSide").addClass("d-none");
          }

          $("#organisatie-detail").removeClass("d-none");
        });
    });
  }

  render() {
    return (
      <div id="detailSide" className="d-none">
        <MyContext.Consumer>
          {(context) => (
            <spinner.BeatLoader
              color="#1ca754"
              loading={context.spinnerIsOpen ? true : false}
              css={this.override}
              size={20}
            />
          )}
        </MyContext.Consumer>

        <div className="detail-title">Gebruiker in detail</div>
        <div className="clearfix">
          <div className="float-left mt-4">
            <a id="detail-button" className="back-page-link" role="button">
              <img src={leftPng} width={9} height={12} /> &nbsp;Terug naar
              Gebruiker
            </a>
          </div>
          <div className="float-right mt-0">
            <a id="user-edit-button" className="button bewerken">
              Bewerken
            </a>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail-active">
              <div className="box-title-1-active">Alias</div>
              <div className="box-title-2-active" id="d-user-alias" />
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Email</div>
              <div className="box-title-2" id="d-user-email" />
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Organisatie</div>
              <div className="box-title-2" id="d-user-organisatie" />
              <span
                className="tooltiptext detail"
                id="d-user-organisatie-tooltip"
              ></span>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Mandate organisatie</div>
              <div className="box-title-2" id="d-user-mandate-organisatie" />
              <span
                className="tooltiptext detail"
                id="d-user-mandate-organisatie-tooltip"
              ></span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Gebruikersrollen</div>
              <div className="box-title-2" id="d-user-gebruikersrollen" />
              <span
                className="tooltiptext detail"
                id="d-user-gebruikersrollen-tooltip"
              ></span>
            </div>
          </div>
          <div className="col-lg-4 text-center">
            <div className="box-detail">
              <div className="box-title-1">Actief</div>
              <label className="switch">
                <input id="d-user-is-active" type="checkbox" disabled />
                <span className="slider-checkbox round" />
              </label>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div className="col-sm-6">
            <div className="inp-labl">Geldig van</div>
            <div className="input-group">
              <div className="input-group-prepend">
                <span className="input-group-text">
                  <img src={dateTimePng} width={30} height={28} />
                </span>
              </div>
              <input
                type="text"
                className="form-control inp-h inpp"
                id="startDate"
                disabled
                placeholder=""
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Detail;
